<!--
 * @Author: yaoyuting
 * @Date: 2020-03-20 19:30:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-01 09:21:06
 * @Descripttion:
-->
<template>
  <div class="foot" ref="element">
    <div class="top">
      <div class="sub_title">
        <ul>
          <li>
            <a target="_blank" class="title">{{ $t("Learn.learn") }}</a>
          </li>

          <router-link to="/pc/NetIntro">
            <li>
              <a target="_blank" class="icon">{{ $t("Learn.introductory") }}</a>
            </li>
          </router-link>

          <router-link to="/pc/NetOver">
            <li>
              <a target="_blank" class="icon">{{ $t("Learn.overview") }}</a>
            </li>
          </router-link>

          <router-link to="/pc/Token">
            <li>
              <a target="_blank" class="icon">{{ $t("Learn.token") }}</a>
            </li>
          </router-link>

          <router-link to="/pc/Client">
            <li>
              <a target="_blank" class="icon">{{ $t("Learn.client1") }}</a>
            </li>
          </router-link>
          <li>
            <p>
              <a
                target="_blank"
                href="http://www.donetwork.io/chainBrowser/#/pc/Index"
                class="icon"
                >{{ $t("Learn.DOnetworkbrowser") }}</a
              >
            </p>
          </li>

          <!-- <li>
            <p @click="promptDilaogBox">
              <a target="_blank" class="icon">{{ $t("Learn.tool") }}</a>
            </p>
          </li> -->
        </ul>
      </div>
      <div class="sub_title">
        <ul>
          <li>
            <a target="_blank" class="title">
              {{ $t("Technology.technology") }}</a
            >
          </li>
          <li>
            <p>
              <a
                href="https://www.donetwork.io/doc/"
                target="_blank"
                class="icon"
                >{{ $t("Technology.wiki") }}</a
              >
            </p>
          </li>

          <router-link to="/pc/Common">
            <li>
              <a target="_blank" class="icon">{{
                $t("Technology.consensus")
              }}</a>
            </li>
          </router-link>

          <router-link to="/pc/Econimucs">
            <li>
              <a target="_blank" class="icon">{{
                $t("Technology.economyDO")
              }}</a>
            </li>
          </router-link>

          <li>
            <p>
              <a target="_blank" class="icon" @click="promptDilaogBox">
                <!-- <a  href="http://47.98.110.210/doc/learn/stake-trustor/stake" target="_blank" class="icon"> -->
                {{ $t("Technology.staking") }}
              </a>
            </p>
          </li>

          <!-- <router-link to="/pc/Organization">
            <li>
              <a target="_blank" class="icon">{{
                $t("Technology.organization")
              }}</a>
            </li>
          </router-link>

          <router-link to="/pc/TechRoadmap">
            <li>
              <a target="_blank" class="icon">{{
                $t("Technology.roadmap2[0]")
              }}</a>
            </li>
          </router-link> -->
        </ul>
      </div>
      <div class="sub_title">
        <ul>
          <li>
            <a target="_blank" class="title">
              {{ $t("Developer.developer") }}</a
            >
          </li>

          <li>
            <p @click="promptDilaogBox">
              <a target="_blank" class="icon">{{
                $t("Developer.documentation")
              }}</a>
            </p>
          </li>

          <li>
            <p @click="promptDilaogBox">
              <a target="_blank" class="icon">
                {{ $t("Developer.application") }}
              </a>
            </p>
          </li>

          <li>
            <p @click="promptDilaogBox">
              <a target="_blank" class="icon">{{ $t("Developer.API") }}</a>
            </p>
          </li>

          <li>
            <p>
              <a
                href="https://www.donetwork.io/doc/"
                target="_blank"
                class="icon"
                >{{ $t("Developer.Start") }}</a
              >
            </p>
          </li>

          <li>
            <p @click="promptDilaogBox">
              <a target="_blank" class="icon">
                <!-- <a href="http://47.98.110.210/doc/learn/stake-trustor/stake" target="_blank" class="icon"> -->
                {{ $t("Developer.client") }}</a
              >
            </p>
          </li>
        </ul>
      </div>
      <div class="sub_title">
        <ul>
          <li>
            <a target="_blank" class="title"> {{ $t("Community.proposal") }}</a>
          </li>
          <li>
            <p @click="promptDilaogBox">
              <a target="_blank" class="icon">{{ $t("Community.pro") }}</a>
            </p>
          </li>

          <li>
            <p @click="promptDilaogBox">
              <a target="_blank" class="icon">{{ $t("Community.Vote") }}</a>
            </p>
          </li>

          <li>
            <p @click="promptDilaogBox">
              <a target="_blank" class="icon">{{ $t("Community.approve") }}</a>
            </p>
          </li>

          <!-- <router-link to="/pc/DAOFund"> -->
          <li>
            <p @click="promptDilaogBox">
              <a target="_blank" class="icon">{{ $t("Fund.title") }}</a>
            </p>
          </li>
          <!-- </router-link> -->
        </ul>
      </div>
      <div class="sub_title">
        <ul>
          <div class="sub_title-D">
            <li>
              <a target="_blank" class="title"> {{ $t("footer.contact") }}</a>
            </li>

            <!-- <router-link to="/pc/Blog"> -->
            <li class="sub_title-li">
              <p @click="promptDilaogBox">
                <a target="_blank" class="icon">{{ $t("Community.blog") }}</a>
              </p>
            </li>
            <!-- </router-link> -->
            <li class="sub_title-li">
              <a target="_blank" href="https://github.com/Do-network">{{
                $t("Community.Github")
              }}</a>
            </li>
            <li class="sub_title-li">
              <a
                target="_blank"
                class="icon"
                href="https://t.me/DoNetworkclub"
                >{{ $t("Community.telegram") }}</a
              >
            </li>

            <li class="sub_title-li">
              <a
                href="https://twitter.com/Donetwork_club"
                target="_blank"
                class="icon"
                >{{ $t("Community.twitter") }}</a
              >
            </li>
            <!-- 
            <li class="sub_title-li">
              <a
                href="https://donetwork.medium.com/"
                target="_blank"
                class="icon"
                >{{ $t("Community.medium") }}</a
              >
            </li>
            <li class="sub_title-li">
              <a
                target="_blank"
                href="https://discord.gg/PNAvkSHJB9"
                class="icon"
              >
                {{ $t("Community.Discord") }}
              </a>
            </li> -->
          </div>
          <!-- <div class="sub_title-D2">
            <li class="sub_title-li">
              <a
                target="_blank"
                href="https://www.youtube.com/channel/UCejTsF2te-_SstSj29sLVhA"
                class="icon"
              >
                {{ $t("Community.Youtube") }}
              </a>
            </li>
          </div> -->
        </ul>
      </div>
    </div>
    <div class="footer-bottm">
      <div class="footer-bottm-w">
        <div class="left">
          <p>{{ $t("Learn.Powered") }}</p>
        </div>
        <div class="right">
          <!-- <p>{{ $t("Learn.Email") }}</p> -->
        </div>
      </div>
    </div>
    <div
      :style="{ height: divH }"
      class="all"
      v-show="flog"
      @touchmove.prevent
      @mousewheel.prevent
    >
      <div class="active">
        <div class="promptDilaogBox">
          <p>in building</p>
          <p @click="promptDilaogBoxBtn" class="promptDilaogBoxBtn">ok</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      flog: false,
      timeout: "",
      divH: 0,
      active: false,
    };
  },
  methods: {
    promptDilaogBoxBtn() {
      this.flog = false;
    },
    promptDilaogBox() {
      this.flog = true;
      this.divH = this.$refs.element.offsetHeight + 1200 + "px";
    },
    goGithub() {
      window.open("https://github.com/uenctech", "_blank");
    },
    goDiscord() {
      window.open("https://discord.com/invite/AAPMAjtcNS", "_blank");
    },
  },
};
</script>
<style>
@font-face {
  font-family: "iconfont"; /* Project id 2700180 */
  src: url("//at.alicdn.com/t/font_2700180_sxhht5d1nu.woff2?t=1627370657062")
      format("woff2"),
    url("//at.alicdn.com/t/font_2700180_sxhht5d1nu.woff?t=1627370657062")
      format("woff"),
    url("//at.alicdn.com/t/font_2700180_sxhht5d1nu.ttf?t=1627370657062")
      format("truetype");
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-discord-line:before {
  content: "\e648";
}

.icon-discord:before {
  content: "\e675";
}

.icon-facebook:before {
  content: "\e641";
}

.icon-github:before {
  content: "\e885";
}

.icon-reddit1:before {
  content: "\e84b";
}

.icon-twitter:before {
  content: "\e749";
}

.iconfont:hover {
  transform: scale(1.2) !important;
  color: white !important;
  margin-right: 40px !important;
}
</style>
<style lang="less" scoped>
.foot {
  position: relative;
  // left: 0;
  bottom: 0;
  height: 530px;
  background: #111111;
  opacity: 1;
  width: 100%;
  color: #9b9da2;
  .top {
    width: 1200px;
    // padding: 0 200px;
    // height: 100%;
    margin: 0 auto;
    display: flex;
    .sub_title {
      margin-top: 40px;
      flex: 1;
      .sub_title-D {
        width: 120px;
        float: left;
      }
      .sub_title-D2 {
        width: 120px;
        float: left;
        margin-top: 48px;
      }
      .sub_title-li {
        width: 130px;
      }
      li {
        // width: 251px;
        // height: 20px;

        cursor: pointer;
      }
    }

    /*.subTitle {*/
    /*  text-align: left !important;*/
    /*  height: 56px;*/
    /*  line-height: 56px;*/
    /*  font-size: 40px;*/
    /*  margin-bottom: 36px;*/
    /*}*/
  }
  ul {
    list-style-type: none;
  }
  li {
    font-size: 15px;
    font-family: Microsoft YaHei UI-Regular, Microsoft YaHei UI;
    font-weight: 400;
    color: #939393;
    line-height: 19px;
    -webkit-background-clip: text;
    padding-top: 28px;
    // padding-bottom: 10px;
    list-style-type: none;
  }
  .title {
    padding-top: 28px;
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    line-height: 19px;
    -webkit-background-clip: text;
  }
  .icon {
    background: #111111;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
  }
}
// 隐藏弹框样式
.all {
  width: 100%;
  background: rgba(4, 13, 35, 0.15000000596046448);
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 998 !important;
}
.promptDilaogBox {
  width: 305px;
  height: 180px;
  background: #f4f5f7;
  border-top: 10px solid #4573e7;
  box-sizing: border-box;
  padding: 47px 98px;
  text-align: center;
  cursor: pointer;
  p {
    text-align: center;
    font-size: 16px;
    font-family: Poppins-SemiBold, Poppins;
    font-weight: 600;
    color: #2b2d41;
    margin: 0;
  }
  .promptDilaogBoxBtn {
    margin-top: 36px;
    width: 110px;
    height: 40px;
    background: #4573e7;
    border-radius: 5px 5px 5px 5px;
    border: none;
    font-size: 16px;
    font-family: Poppins-SemiBold, Poppins;
    font-weight: 600;
    color: #ffffff;
    line-height: 22px;
    box-sizing: border-box;
    line-height: 40px;
    cursor: pointer;
  }
}
.active {
  position: absolute;
  bottom: 25%;
  left: 40%;
  z-index: 999 !important;
  // transform: translate(75%, 60%);
}
.footer-bottm {
  width: 100%;
  margin-top: 60px;
  .footer-bottm-w {
    width: 1200px;
    border-top: 1px solid rgba(147, 147, 147, 0.5);
    margin: 0 auto;
    p {
      font-size: 12px;
      font-family: Microsoft YaHei UI-Regular, Microsoft YaHei UI;
      font-weight: 400;
      color: #939393;
      line-height: 14px;
      -webkit-background-clip: text;
      margin-top: 40px;
    }
    .left {
      width: 50%;
      height: 100%;
      display: inline-block;
      text-align: left;
    }
    .right {
      width: 50%;
      height: 100%;
      display: inline-block;
      text-align: right;
    }
  }
}
</style>
